import { Input, Autocomplete, AutocompleteItem } from "@heroui/react";
import { FilterCard } from "@/components/data-table";

const FilterData = ({ table, initialFilters = {}, filterOptions }) => {
    const { materials } = filterOptions;
    const { pending, setPending, isOpen, apply, clear } = table.filterPanel;

    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            {/* Nama Formula */}
            <Input
                label="Nama Formula"
                placeholder="Cari nama formula..."
                value={pending.name || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({ ...prev, name: val }))
                }
                variant="flat"
                isClearable
            />

            {/* Produk Hasil */}
            <Autocomplete
                label="Produk Hasil"
                placeholder="Semua produk"
                selectedKey={
                    pending.material_id ? String(pending.material_id) : null
                }
                onSelectionChange={(key) =>
                    setPending((prev) => ({
                        ...prev,
                        material_id: key || "",
                    }))
                }
                variant="flat"
                isClearable
            >
                {materials.map((m) => (
                    <AutocompleteItem key={String(m.value)} value={m.value}>
                        {m.title}
                    </AutocompleteItem>
                ))}
            </Autocomplete>
        </FilterCard>
    );
};

export default FilterData;
